var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaiting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.594,
    height: 16.594,
    viewBox: "0 0 16.594 16.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2821",
    "data-name": "Grupo 2821",
    transform: "translate(-11458.001 -1436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2807",
    "data-name": "Grupo 2807",
    transform: "translate(11368.644 1418.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6143",
    "data-name": "Trazado 6143",
    d: "M97.654,19.918a5.462,5.462,0,1,1-5.463,5.462,5.468,5.468,0,0,1,5.463-5.462m0-2.835a8.3,8.3,0,1,0,8.3,8.3,8.3,8.3,0,0,0-8.3-8.3Z",
    fill: "#bad6f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2809",
    "data-name": "Grupo 2809",
    transform: "translate(11368.644 1418.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6144",
    "data-name": "Trazado 6144",
    d: "M92.191,25.38a5.444,5.444,0,0,1,1.6-3.86l-2.006-2.007a8.3,8.3,0,0,0,0,11.734l2.006-2.006A5.447,5.447,0,0,1,92.191,25.38Z",
    fill: "#007ecd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.72e8d7e6412fc879924b1f2587035d7a.svg";
export { ForwardRef as ReactComponent };